<template>
    <div class="__upload">
        <label
            class="__img"
            v-for="(image, index) in value"
            :key="index"
            @click="selectImage(image)"
        >
            <span class="__img_wrap" :class="(chooseImage == image && type == 'select') ? '__active' : ''">
                <img :src="image" />
            </span>
        </label>

        <label class="__input" v-if="type != 'select' && !disableAddNew">
            <input type="file" @input="handleImage('imageAdd')" ref="imageAdd" />
        </label>

        <LayoutPopup :id="`cap-nhat-hinh-anh-${chooseImage}`" :size="'small'">
            <template #title>Cập nhật hình ảnh</template>
            <template #content>
                <label class="__update" >
                    <input type="file" @input="handleImage('imageUpdate')" ref="imageUpdate" style="display: none"/>
                    <img :src="chooseImage" />
                </label>
            </template>
            <template #control-left>
                <BaseButton size="sm" variant="danger" @click="deleteImage">
                    Xoá
                </BaseButton>
            </template>
            <template #control-right>
                <BaseButton
                    size="sm"
                    variant="secondary"
                    type="button"
                    @click="hidePopup(`cap-nhat-hinh-anh-${chooseImage}`)"
                >
                    Thoát
                </BaseButton>
                <BaseButton type="button" size="sm" @click="submitUpdate">
                    Hoàn tất
                </BaseButton>
            </template>
        </LayoutPopup>
    </div>
</template>

<script>
import Swal from "sweetalert2";

import { OtherService } from "@/services/other.service"

export default {
    components: {
    },

    props: {
        value: {
            type: Array,
            default: () => [],
        },

        type: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            chooseImage: "",
            chooseImageTmp: "",
            valueTmp: [],
            disableAddNew: false
        }
    },


    methods: {
        selectImage(image) {
            if (this.type != 'select') {
                this.chooseImage = image
                this.chooseImageTmp = image
                this.showPopup(`cap-nhat-hinh-anh-${this.chooseImage}`)
            } else {
                this.chooseImage = image
                this.$emit('value', this.chooseImage)
            }
        },

        deleteImage() {
            const index = this.value.findIndex((e) => e == this.chooseImageTmp)
            this.value.splice(index, 1)
            this.hidePopup(`cap-nhat-hinh-anh-${this.chooseImage}`)
        },

        submitUpdate() {
            const index = this.value.findIndex((e) => e == this.chooseImageTmp)
            this.value.splice(index, 1, this.valueTmp[0])
            this.hidePopup(`cap-nhat-hinh-anh-${this.chooseImage}`)
        },

        //  giá trị type có 2 loại cho add và update
        handleImage(type) {
            const input = (type == 'imageUpdate') ? this.$refs.imageUpdate : this.$refs.imageAdd 
            const image = input.files[0]
            const fomatUpload = ["image/jpeg", "image/png"]
            
            const checkFomat = fomatUpload.includes(image.type)
            if (!checkFomat) {
                Swal.fire({
                    title: "Thông báo",
                    html: 'Ảnh chọn sai định dạng',
                    text: "Ảnh chọn sai định dạng (.PNG, .JPG). Vui lòng chọn ảnh khác.",
                    confirmButtonColor: "#34c38f",
                    confirmButtonText: "Xác nhận",
                    imageUrl: require("@/assets/images/exclamation-triangle.svg"),
                    imageWidth: 125,
                    imageHeight: 125,
                })
                return
            }

            const FileSize = image.size / 1024 / 1024
            if (FileSize > 2) {
                Swal.fire({
                    title: "Thông báo",
                    html: 'Dung lượng ảnh quá lớn',
                    text: "Dung lượng tối đa ảnh tải lên là 2MB (.PNG .JPG .JPEG .GIF). Vui lòng chọn ảnh khác.",
                    confirmButtonColor: "#34c38f",
                    confirmButtonText: "Xác nhận",
                    imageUrl: require("@/assets/images/exclamation-triangle.svg"),
                    imageWidth: 125,
                    imageHeight: 125,
                })
                return
            }

            const formData = new FormData()
            formData.append("image", image)

            this.uploadImage(formData, type)
        },

        async uploadImage(formData, type) {
            try {
                const dataRes = await OtherService.uploadImage(formData)
                if (dataRes.success && type == 'imageAdd') {
                    this.value.push(dataRes.data.imageLink)
                } else {
                    this.valueTmp = []
                    this.valueTmp.push(dataRes.data.imageLink)
                    this.chooseImage = dataRes.data.imageLink
                }
                if (this.type === 'avatar') {
                    this.disableAddNew = true
                }
            } catch (error) {
                console.log(error)
            }
        },
    },

    watch: {
        value: {
            handler: function() {
                if (this.value.length === 0) {
                    this.disableAddNew = false
                }
                this.$emit('value', this.value)
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.__upload {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: 12px;

    > *:not(:first-child) {
        // margin-left: 24px;
    }

    .__img {
        display: flex;
        flex-direction: column;
        place-items: center;

        .__img_wrap {
            height: 80px;
            width: 80px;
            margin: 0;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #ffffff;
            cursor: pointer;
            border: 1px solid #dddddd;

            padding: 4px;
            border-radius: 4px;
            box-sizing: border-box;
            transition: background ease-in-out 300ms;

            &:hover {
                background: #f9f9f9;
            }
        }
    }

    .__input {
        display: flex;
        flex-direction: column;
        place-items: center;

        input[type="file"] {
            display: none;
        }

        &::before {
            content: "";
            display: block;
            height: 80px;
            width: 80px;
            background: #ffffff;
            cursor: pointer;
            border: 1px dashed #dddddd;
            box-sizing: border-box;
            border-radius: 4px;
            background: url("data:image/svg+xml,%0A%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M23.3333 14.6667H17.3333V8.66667C17.3333 8.33333 17 8 16.6667 8H15.3333C14.9583 8 14.6667 8.33333 14.6667 8.66667V14.6667H8.66667C8.29167 14.6667 8 15 8 15.3333V16.6667C8 17.0417 8.29167 17.3333 8.66667 17.3333H14.6667V23.3333C14.6667 23.7083 14.9583 24 15.3333 24H16.6667C17 24 17.3333 23.7083 17.3333 23.3333V17.3333H23.3333C23.6667 17.3333 24 17.0417 24 16.6667V15.3333C24 15 23.6667 14.6667 23.3333 14.6667Z' fill='%23ACAEBB'/%3E%3C/svg%3E%0A")
                center center no-repeat;
        }
    }
}

.__update {
    cursor: pointer;
    background: #ffffff;
    border: 1px solid #bdc1c5;
    box-sizing: border-box;
    box-shadow: inset 0px 0px 0px 4px #ffffff;
    padding: 4px;
    border-radius: 4px;
    width: 100%;
    display: flex;
    aspect-ratio: 1;
    justify-content: center;
    align-content: center;
    align-items: center;
}

.__active {
    background: #437de8 !important;
}
</style>
